import { useState, useEffect, createElement, Fragment } from "react";

const OnlyRenderOnClient = ({ children }: React.PropsWithChildren) => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null;
    }

    // eslint-disable-next-line react/no-children-prop
    return createElement(Fragment, { children });
};

export default OnlyRenderOnClient;
